module.exports = __webpack_public_path__ + "static/media/nzcafemap_ad.72a61002.jpg";